<template>
    <md-dialog :md-active="showVersionDialog">
        <md-dialog-title>{{ $t("layout.footer.Terms") }} </md-dialog-title>
        <md-dialog-content>
            <table>
                <tr>
                    <th>{{ $t("layout.footer.version") }}</th>
                    <th>{{ $t("layout.footer.valid") }}</th>
                    <th>{{ $t("layout.footer.file") }}</th>
                </tr>
                <tr>
                    <td>{{currentTermAndCondition.version}}</td>
                    <td>{{currentTermAndCondition.validFrom}}</td>
                    <td>
                        <a :href="link.currentTermAndCondition" target="_blank">
                            {{ $t("layout.footer.termAndCondition.current") }}
                        </a>
                    </td>
                </tr>
                <tr v-if="hasMultiTermAndCondition">
                    <td>{{nextTermAndCondition.version}}</td>
                    <td>{{nextTermAndCondition.validFrom}}</td>
                    <td>
                        <a :href="link.nextTermAndCondition" target="_blank">
                            {{ $t("layout.footer.termAndCondition.next") }}
                        </a>
                    </td>
                </tr>
            </table>
        </md-dialog-content>

        <md-dialog-actions>
            <md-button class="md-primary" @click="showVersionDialog = false">{{ $t("common.close") }}</md-button>
        </md-dialog-actions>
    </md-dialog>
</template>

<script>
import {platformDocumentApi} from "@/common/api/platformDocumentApi";
import APP from "@/common/appConfig";
import {formatAsLocalizedDate} from "@/common/format";

export default {
    data() {
        return {
            showVersionDialog: false,
            hasMultiTermAndCondition: false,
            currentTermAndCondition: {
                version: "",
                validFrom: ""
            },
            nextTermAndCondition: {
                version: "",
                validFrom: ""
            },
            link: {
                currentTermAndCondition: APP.DOMAIN + "platformdoc/term-and-condition",
                nextTermAndCondition: APP.DOMAIN + "platformdoc/next-term-and-condition"
            }
        }
    },
    methods: {
        show() {
            platformDocumentApi.getGeneralTermAndConditionInfo()
                .then(res => {
                    this.hasMultiTermAndCondition = res.hasMultiTermAndCondition;
                    this.currentTermAndCondition.version = res.current.version;
                    this.currentTermAndCondition.validFrom = formatAsLocalizedDate(res.current.validFrom);

                    if (this.hasMultiTermAndCondition) {
                        this.nextTermAndCondition.version = res.next.version;
                        this.nextTermAndCondition.validFrom = formatAsLocalizedDate(res.next.validFrom);
                    }

                    this.showVersionDialog = true;
                })
                .catch(err => {
                    this.toast(err);
                });
        },
    }
};
</script>